import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/AuthContext";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import InitiativesList from "@/pages/InitiativesList";
import InitiativeDetail from "@/pages/InitiativeDetail";
import CSR from "@/pages/CSR";
import Donate from "@/pages/Donate";
import DonationSuccess from "@/pages/DonationSuccess";
import Contact from "@/pages/Contact";
import Events from "@/pages/Events";
import Volunteer from "@/pages/Volunteer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import WhatsAppFab from "@/components/WhatsAppFab";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/initiatives" element={<InitiativesList />} />
              <Route path="/initiatives/:slug" element={<InitiativeDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/csr" element={<CSR />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/donation/success" element={<DonationSuccess />} />
              <Route path="/events" element={<Events />} />
              <Route path="/volunteer" element={<Volunteer />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/login" element={<AdminLogin />} />
            </Route>
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <WhatsAppFab />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
